import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=d4fa762a&scoped=true&"
import script from "./TaskCard.vue?vue&type=script&lang=ts&"
export * from "./TaskCard.vue?vue&type=script&lang=ts&"
import style0 from "./TaskCard.vue?vue&type=style&index=0&id=d4fa762a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fa762a",
  null
  
)

export default component.exports